/*
 * BeSeparator. Costs zero layout space; `fit` decides where the rule sits.
 * Orientation is inferred from the parent stack or row.
 */

import { type BeProps, beComponent } from "./create.tsx";

export type BeSeparatorFit = "flush" | "centred" | "overlap" | "spaced";

export type BeSeparatorProps = BeProps<
	"hr",
	{
		fit?: BeSeparatorFit;
		bleed?: boolean;
	}
>;

export const BeSeparator = beComponent<BeSeparatorProps, HTMLHRElement>("BeSeparator", (props, be) => {
	const { fit = "flush", bleed, scale, className, style, ...rest } = props;
	return <hr {...rest} {...be("be-separator", fit !== "flush" && `is-${fit}`, bleed && "is-bleed")} />;
});
